import { createContext, useContext, useReducer } from "react";

type Action = {
  type: "SET_DAY_WIDTH";
  width: number;
};

type State = {
  dayWidth: number;
};

type Dispatch = (action: Action) => void;

const ResourcesContext = createContext<
  { state: State; dispatch: Dispatch } | undefined
>(undefined);

function resourcesReducer(state: State, action: Action): State {
  switch (action.type) {
    case "SET_DAY_WIDTH":
      return { ...state, dayWidth: action.width };
    default:
      return state;
  }
}

export const ResourcesContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [state, dispatch] = useReducer(resourcesReducer, { dayWidth: 18 });
  return (
    <ResourcesContext.Provider value={{ state, dispatch }}>
      {children}
    </ResourcesContext.Provider>
  );
};

export const useResourcesContext = () => {
  const context = useContext(ResourcesContext);
  if (!context) {
    throw new Error(
      "useResourcesContext must be used within a ResourcesContextProvider"
    );
  }
  return context;
};
